module.exports = __webpack_public_path__ + "img/title+.51835bf5.png";